angular.module('TetherApp').controller('ListenerRuleController', [
	'$window',
	'$location',
	'$anchorScroll',
	'listenerRuleService',
	function (
		$window,
		$location,
		$anchorScroll,
		listenerRuleService
	) {
		let self = this;
		self.rulesData = [];

		self.init = function () {
			if(window.rulesData != undefined) {
				angular.forEach(window.rulesData, function( value, key ) {
					self.rulesData.push(value);
				}, self);
			}
		};

		self.create = function () {
			data = {};

			data.id = null;
			data.data_key = self.newDataKey;
			data.data_value = self.newDataValue;

			// console.log(data.data_key);

			if(!data.data_key || !data.data_value) {
				self.hasError = 1;
			} else {
				self.hasError = 0;

				self.rulesData.push(
					data
				);

				self.newDataKey = null;
				self.newDataValue = null;
			}
		};

		self.delete = function(key) {
			self.rulesData.splice(key, 1);
		};

	}
]);
